import { useQuery, useMutation } from "@tanstack/react-query";
import {
  generalSettingShow,
  generalSettingUpdate,
} from "api/siteSettings/generalSetting";
import { useEffect } from "react";
import {
  setGeneralSettingAction,
  updateGeneralSettingAction,
} from "redux/reducers/siteSettings/generalSetting";
import { printError, useSearch, useUtilities } from "helpers";
import { ApiResponseType, NotificationType } from "enums";
import { t } from "i18next";

function useGetGeneralSettings(web) {
  return useQuery(["generalSettings", web], () => generalSettingShow(web));
}

export function useGeneralSettings() {
  const { web = null } = useSearch();
  const { data, isLoading, error } = useGetGeneralSettings(web);
  const {
    dispatch,
    generalSettings: { generalSettings, loaded, website_id },
  } = useUtilities();

  useEffect(() => {
    if (data && (website_id !== web)) {
      dispatch(
        setGeneralSettingAction({ generalSettings: data.data, website_id: web })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, error, loaded, web, website_id]);

  return {
    data: generalSettings,
    isLoading: (isLoading || !loaded || web !== website_id),
    error,
  };
}

export function useUpdateGeneralSettings() {
  const { notification, dispatch } = useUtilities();
  return useMutation(generalSettingUpdate, {
    onSuccess: (data) => {
      if (data.status_code === ApiResponseType.SUCCESS) {
        dispatch(updateGeneralSettingAction(data.data));
        notification({
          type: NotificationType.SUCCESS,
          message: t("siteSetting.generalSettings.updateSuccessMessage"),
        });
      } else {
        notification({
          type: NotificationType.ERROR,
          message: printError(data.message),
        });
      }
    },
    onError: (err) => {
      notification({
        type: NotificationType.ERROR,
        message: printError(err.message),
      });
    },
  });
}
